import React from "react";

interface StepLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function StepLayout({ title, children }: StepLayoutProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium">{title}</h2>
      </div>
      {children}
    </div>
  );
} 